import React from 'react';
import AsyncPage from './async';
import DefaultBusinessLayout from '../../../../components/layout/DefaultBusinessLayout';

export default (
  <DefaultBusinessLayout
    key="/business/color-trends/applied/:id"
    exact
    path="/business/color-trends/applied/:id"
    component={AsyncPage}
    breadcrumb={[
      {
        position: 1,
        name: 'Home',
        item: '/',
      },
      {
        position: 2,
        name: 'Business',
        item: '/business',
      },
      {
        position: 3,
        name: 'Color Trends Applied',
        item: '/business/color-trends/applied',
      },
    ]}
  />
);
